// Set up all fields and multiple validators for each
import React, { useEffect } from "react";
import * as yup from "yup";
import { useField } from "formik";

import FormHelperText from "@material-ui/core/FormHelperText";
import { KeyboardDatePicker } from "@material-ui/pickers/";

import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";

export const initial = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, null> => ({
  [keyFromIdentity(question.identity, parent, index)]: null,
});

export const validator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const key = keyFromIdentity(question.identity, parent, index);
  const value = yup.string().nullable();
  return {
    [key]: question.required ? value.required() : value,
  };
};

const DatePickerField = (props: any): React.ReactElement => {
  const [field, meta, helpers] = useField(props);
  const { name, value } = field;
  const { touched, error } = meta;
  const { setValue, setTouched } = helpers;
  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);

  return (
    <>
      <KeyboardDatePicker
        disableFuture={props.name.includes("dob") || props.name.includes("birth") || props.disableFuture}
        fullWidth
        style={{ minWidth: "15em" }}
        error={meta.touched && !!meta.error}
        minDateMessage=""
        maxDateMessage=""
        invalidDateMessage=""
        margin="dense"
        name={name}
        autoComplete="off"
        autoOk
        variant="inline"
        inputVariant="outlined"
        required={props.required}
        label={props.title}
        format="MM/dd/yyyy"
        placeholder="01/22/2020"
        value={value}
        InputLabelProps={{ shrink: true }}
        InputAdornmentProps={{ position: "end" }}
        onClick={() => setTouched(true)}
        onChange={date => {
          // @ts-ignore
          if (date === null || (date instanceof Date && !isNaN(date))) {
            setValue(date);
            setTouched(true);
          }
        }}
        disabled={!!props.disabled}
      />
      {touched && error && <FormHelperText className="color-hc-error">{error}</FormHelperText>}
    </>
  );
};
DatePickerField.validator = validator;
DatePickerField.initial = initial;

export default DatePickerField;
